import isEqualWith from 'lodash/isEqualWith'
import { useEffect, useRef, useState } from 'react'

const getInitialState = (object, keys) => {
  let result = {}

  for (let key of keys) {
    result[key] = object ? object[key] : undefined
  }

  return result
}

export function useFormState(
  object,
  keys,
): [
  object,
  (key: string, value: any, callback?: (...args: Array<any>) => void) => void,
  boolean,
] {
  const [state, setState] = useState(getInitialState(object, keys))
  const [initialState, setInitialState] = useState(null)
  const pendingChanges =
    initialState !== null &&
    !isEqualWith(state, initialState, (a, b) => {
      if (!Boolean(a)) return !Boolean(b)
    })
  const callbackRef = useRef(null)
  useEffect(() => {
    setState(getInitialState(object, keys))
    setInitialState(getInitialState(object, keys))
  }, [keys, object])

  const handleSetState = (key, value, callback) => {
    if (callback) {
      callbackRef.current = callback
    }

    setState(state => ({ ...state, [key]: value }))
  }

  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(state)
      callbackRef.current = null
    }
  }, [state])
  return [state, handleSetState, pendingChanges]
}
